import DropdownTemplateView from '../../../../DropdownTemplateView'
import {trim} from '../../../../atUtils'
import {corporateHolidayEditorModes} from '../../constants'
import messageResource from '../../../../messageResource'
import $ from 'jquery'
import SimpleMenu, { Option } from '../../../../components/SimpleMenu'

export default class CorporateHolidayEditor extends DropdownTemplateView {
    constructor({
        editCallback = () => {},
        deleteCallback = () => {},
    } = {}) {
        super()

        this.callbacks = {
            editCallback,
            deleteCallback,
        }

        this.state = {
            date: null,
            title: '',
            showMarkAsWorkingButton: false,
            mode: corporateHolidayEditorModes.CHANGE_NAME,
        }

        this.onStatePropertyChanged('showMarkAsWorkingButton', (show) => this.$markAsRegularNonworkingButton.toggle(show))

        this.onStatePropertyChanged('title', (title) => {
            this.$title.pVal(title)
        })
    }

    templateHtml() {
        return '<div class="corporateHolidayEditor"></div>'
    }

    afterRender() {
        this.simpleMenu = new SimpleMenu().init(this.$el)

        const holidayEditor = $(
            '<div class="editorSection">' +
            '    <input class="titleInput" type="text" maxlength="80"/>' +
            '</div>'
        )
        holidayEditor.appendTo(this.simpleMenu.$el)
        this.$title = this.find('.titleInput')

        this.$markAsRegularNonworkingButton = new Option({
            onSelected: () => {
                this.setStateInternal({
                    mode: corporateHolidayEditorModes.DELETE,
                })
                this.callbacks.deleteCallback(this.state.date)
                this.hide()
            }
        }).init(this.simpleMenu.$el)
        this.$markAsRegularNonworkingButton.toggle(false)
        this.$markAsRegularNonworkingButton.setState({
            title: messageResource.getMessage('work_schedule.mark_as_regular_nonworking_day'),
        })

        this.$markAsWorkingButton = new Option({
            onSelected: () => {
                if (this.state.showMarkAsWorkingButton) {
                    this.setStateInternal({
                        mode: corporateHolidayEditorModes.MARK_AS_WORKING,
                    })
                    this.callbacks.editCallback(this.state.date, true, '')
                } else {
                    this.setStateInternal({
                        mode: corporateHolidayEditorModes.DELETE,
                    })
                    this.callbacks.deleteCallback(this.state.date)
                }
                this.hide()
            }
        }).init(this.simpleMenu.$el)
        this.$markAsWorkingButton.setState({
            title: messageResource.getMessage('work_schedule.mark_as_working_day'),
        })

        this.renderInitialState()
    }

    onShow() {
        super.onShow()
        this.onShowCallback()
        this.setStateInternal({
            mode: corporateHolidayEditorModes.CHANGE_NAME,
        })
    }

    setOnShowCallback(callback) {
        this.onShowCallback = callback
    }

    onHide() {
        super.onHide()
        this.onHideCallback()
        if (this.state.mode === corporateHolidayEditorModes.CHANGE_NAME) {
            let newTitle = trim(this.$title.pVal()) === ''
                ? messageResource.getMessage('work_schedule.corporate_holiday')
                : trim(this.$title.pVal())
            if (this.state.title !== newTitle)
                this.callbacks.editCallback(this.state.date, false, newTitle)
        }
    }

    setOnHideCallback(callback) {
        this.onHideCallback = callback
    }

    mouseDownTargetElement() {
        return $(document)
    }
}



// WEBPACK FOOTER //
// ./web/js/administration/workSchedule/components/month/CorporateHolidayEditor.js